/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ClusterStates } from '../../server';
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
});

export const GetClusterStatus = {
  id: 'cluster-status.get',
  tag: 'Cluster',
  summary: 'Get cluster status',
  description: 'Retrieve the status of a cluster',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/status`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: { 'application/json': { schema: z.strictObject({ status: z.nativeEnum(ClusterStates) }) } },
    },
  },
} as const satisfies Endpoint;
